<div class="loader-wrapper" [class.d-none]="!show"> 
    <div class="loader">
      <img src="assets/images/logo/logo-icon.png" alt="Logo image" />
    </div>
  </div>